import * as React from 'react';

import {EmptyStateSmall} from '../empty-states/empty-state-small';
import {NothingFoundEmptyState} from '../empty-states/nothing-found-empty-state';
import {ErrorState} from '../error-state/error-state';
import {LoadingPage} from '../loading-page/loading-page';

import {Table} from './table';
import type {Column} from './table-types';
import type {SpecialState} from './types';

type Props = {
    onSelectRow: (row: any) => void;
    selectedRowId: string | null | undefined;
    columns: Column<any>[];
    data: any[];
    isLoading: boolean;
    error: string | null | undefined;
    isFiltering?: boolean;
    emptyStateTitle?: string;
    emptyStateSubtitle?: string;
    fullWidth?: boolean;
    specialStates?: SpecialState[];
    hasHeaderLeftBorder?: boolean;
    hasHeaderRightBorder?: boolean;
    hasHeaderTopBorder?: boolean;
};

export function SelectionTable(props: Props) {
    const {fullWidth = true} = props;

    const defaultSpecialStates = [
        {
            shouldRender: () => Boolean(props.error),
            component: <ErrorState errorMessage={props.error} />,
        },
        {
            shouldRender: () => props.isLoading && !props.data.length,
            component: <LoadingPage padding={4} />,
        },
        {
            shouldRender: () =>
                !props.error && !props.data.length && !props.isLoading && !props.isFiltering,
            component: (
                <EmptyStateSmall
                    title={props.emptyStateTitle || 'Nothing found'}
                    subtitle={props.emptyStateSubtitle || ''}
                />
            ),
        },
        {
            shouldRender: () =>
                !props.error &&
                !props.data.length &&
                !props.isLoading &&
                Boolean(props.isFiltering),
            component: <NothingFoundEmptyState />,
        },
    ];

    return (
        <div className='full-width full-height'>
            <Table
                hasHeaderBorder={true}
                hasHeaderCellBorders={true}
                hasHeaderLeftBorder={props.hasHeaderLeftBorder}
                hasHeaderRightBorder={props.hasHeaderRightBorder}
                hasHeaderTopBorder={props.hasHeaderTopBorder}
                hasHoverState={true}
                isCompact={true}
                hasBorders={true}
                fullWidth={fullWidth}
                disableFilters={true}
                onSelectRow={props.onSelectRow}
                selectedRowId={props.selectedRowId}
                // Removes "triple sort" and forces there
                // always to be a asc/desc sort applied
                disableSortRemove={true}
                columns={props.columns}
                data={props.data}
                specialStates={props.specialStates || defaultSpecialStates}
            />
        </div>
    );
}
